"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageAttemptRecoveredEvent = void 0;
class MessageAttemptRecoveredEvent {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageAttemptRecoveredEvent.attributeTypeMap;
    }
}
exports.MessageAttemptRecoveredEvent = MessageAttemptRecoveredEvent;
MessageAttemptRecoveredEvent.discriminator = undefined;
MessageAttemptRecoveredEvent.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "MessageAttemptRecoveredEventData",
        "format": ""
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "MessageAttemptRecoveredEventTypeEnum",
        "format": ""
    }
];
//# sourceMappingURL=MessageAttemptRecoveredEvent.js.map